"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const core_1 = require("@material-ui/core");
const react_content_loader_1 = require("react-content-loader");
const CardContentLoaderStyle_1 = require("./jss/CardContentLoaderStyle");
const loyaltyContentLoaderSvg = ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("rect", { width: "303", height: "32", x: "0", y: "0", rx: "4", ry: "4" }), (0, jsx_runtime_1.jsx)("rect", { width: "345", height: "343", x: "0", y: "56", rx: "6", ry: "6" }), (0, jsx_runtime_1.jsx)("rect", { width: "214", height: "18", x: "0", y: "423", rx: "4", ry: "4" }), (0, jsx_runtime_1.jsx)("rect", { width: "315", height: "25", x: "0", y: "458", rx: "4", ry: "4" })] }));
const CardContentLoader = ({ classes, loaderStyle, customSvgShapes, customHeight = 500, customSpeed = 3, primaryColor = '#ffffff', secondaryColor = '#eeeeee' }) => {
    let contentLoader;
    switch (loaderStyle) {
        case 'instagram':
            contentLoader = (0, jsx_runtime_1.jsx)(react_content_loader_1.Instagram, {});
            break;
        case 'code':
            contentLoader = (0, jsx_runtime_1.jsx)(react_content_loader_1.Code, {});
            break;
        case 'list':
            contentLoader = (0, jsx_runtime_1.jsx)(react_content_loader_1.List, {});
            break;
        case 'bulletlist':
            contentLoader = (0, jsx_runtime_1.jsx)(react_content_loader_1.BulletList, {});
            break;
        case 'loyalty':
            contentLoader = ((0, jsx_runtime_1.jsx)(react_content_loader_1.default, Object.assign({ height: customHeight, speed: customSpeed, backgroundColor: primaryColor, foregroundColor: secondaryColor }, { children: loyaltyContentLoaderSvg })));
            break;
        case 'custom':
            contentLoader = ((0, jsx_runtime_1.jsx)(react_content_loader_1.default, Object.assign({ height: customHeight, speed: customSpeed, backgroundColor: primaryColor, foregroundColor: secondaryColor }, { children: customSvgShapes })));
            break;
        case 'facebook':
        default:
            contentLoader = (0, jsx_runtime_1.jsx)(react_content_loader_1.Facebook, {});
            break;
    }
    return (0, jsx_runtime_1.jsx)("div", Object.assign({ className: classes.root }, { children: contentLoader }));
};
exports.default = (0, core_1.withStyles)(CardContentLoaderStyle_1.default)(CardContentLoader);
//# sourceMappingURL=CardContentLoader.js.map